import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/df-admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/df-admin/skills" });
  },
});
